// contains learning group specific user permissions (learning group = a single instance of the engagement server)
// contains disclaimer data that has been specified for the respective realm for the use of engagement server
import { FETCH_SOCIAL_CONFIG_SUCCESS } from "../actions";
import initialState from "./initialState";
export default function socialConfig() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState.socialConfig, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case FETCH_SOCIAL_CONFIG_SUCCESS:
            return action.socialConfig;
        default:
            return state;
    }
}
